import React from 'react'
import { confPassLogo } from '../../../../assets'
import { CheckoutContext } from '../../../../contexts/CheckoutContext'
import RouterHook from '../../../../contexts/RouterHook'

export default function PixAprovado() {
  const { sttCtxChkt } = React.useContext(CheckoutContext)
  const serverRouter = RouterHook()
  //console.log('sttCtxChkt', sttCtxChkt)
  return (
    <>
      <h2 className='title-pag-me-pix'>Pagamento aprovado</h2>
      <div className='contain-img-pix'>
        <img className='img-pag-me-pix' src={confPassLogo} alt='Logo de confirmação de pagamento' />
        <h3 className='contain-informacoes-pix-paragrafo'>O seu pagamento foi aprovado</h3>
        <button
          className='btt-pag-me-pix-agendar'
          onClick={() => {
            if (sttCtxChkt.modePay === 'PEDIDO') {
              serverRouter('agendamento', sttCtxChkt.pedidoPix.idpedido)
            } else {
              serverRouter('diaria', sttCtxChkt.diariaPix.idcompraDayuse)
            }
          }}
        >
          {sttCtxChkt.modePay === 'PEDIDO' ? 'Ir para o agendamento' : 'Ir para a diária'}
        </button>
      </div>
    </>
  )
}
